/**
 * Theme module — types, primitives, semantic palette, and MUI theme instances.
 * Import from '@/globalStyles/theme' for the public API.
 */
import { createTheme } from '@mui/material';
import type { ThemeOptions } from '@mui/material/styles';

import './types';

import {
    lightThemeOptions,
    darkThemeOptions,
    hlDarkThemeOptions,
    hlLightThemeOptions,
} from './themes';

export type {
    Primitives,
    ColorScale,
    ColorScaleKey,
    SemanticPalette,
    SemanticConfig,
} from './types';
export { COLOR_SCALE_KEYS } from './types';
export { primitives, darkPrimitives, lightPrimitives } from './primitives';
export { buildSemanticPalette } from './semantic';
export { lightThemeOptions, darkThemeOptions, hlDarkThemeOptions, hlLightThemeOptions };

const defaultLight = createTheme();

export const lightTheme = createTheme({
    ...defaultLight,
    ...lightThemeOptions,
} as ThemeOptions);

export const darkTheme = createTheme({
    ...defaultLight,
    ...darkThemeOptions,
} as ThemeOptions);

export const hypertrackerTheme = createTheme({
    ...defaultLight,
    ...hlDarkThemeOptions,
} as ThemeOptions);

export const hypertrackerLightTheme = createTheme({
    ...defaultLight,
    ...hlLightThemeOptions,
} as ThemeOptions);
